import axios from 'axios';

const _ = require('lodash');
import {ExportToCsv} from 'export-to-csv';
import tickets from "../../helpers/tickets";
import router from '../../router';

const PARAMS_BLANK_SLATE = {
    date_ticket_opened: {
        start_date: null,
        end_date: null
    },
    date_ticket_closed: {
        start_date: null,
        end_date: null
    },
    date_ticket_resolved: {
        start_date: null,
        end_date: null
    }
};

export const state = {
    report: {
        id: null,
        name: 'Untitled Report',
        description: null,
        query: null
    },
    results: null,
    metrics: null,
    filtersEnabled: [],
    params: _.cloneDeep(PARAMS_BLANK_SLATE),
    isLoading: false,
    isLoadingAgents: false,
    isLoadingTravelConsultantNames: false,
    isSaving: false,
    isDeleting: false,
    agents: [],
    travelConsultantNames: [],
    serverErrors: [],
    updateKey: 1
}

export const mutations = {
    START_LOADING(state) {
        state.isLoading = true;
    },

    STOP_LOADING(state) {
        state.isLoading = false;
    },

    START_DELETING(state) {
        state.isDeleting = true;
    },

    STOP_DELETING(state) {
        state.isDeleting = false;
    },

    START_LOADING_AGENTS(state) {
        state.isLoadingAgents = true;
    },

    STOP_LOADING_AGENTS(state) {
        state.isLoadingAgents = false;
    },

    START_LOADING_TRAVEL_CONSULTANT_NAMES(state) {
        state.isLoadingTravelConsultantNames = true;
    },

    STOP_LOADING_TRAVEL_CONSULTANT_NAMES(state) {
        state.isLoadingTravelConsultantNames = false;
    },

    START_SAVING(state) {
        state.isSaving = true;
    },

    STOP_SAVING(state) {
        state.isSaving = false;
    },

    SET_REPORT(state, report) {
        state.report = report;
    },

    SET_NAME(state, name) {
        state.report.name = name;
    },

    SET_PARAMS(state, params) {
        state.params = params;
    },

    SET_AGENTS(state, agents) {
        state.agents = agents;
    },

    SET_TRAVEL_CONSULTANT_NAMES(state, travelConsultantNames) {
        state.travelConsultantNames = travelConsultantNames;
    },

    SET_RESULTS(state, results) {
        state.results = results;
    },

    SET_METRICS(state, metrics) {
        state.metrics = metrics;
    },

    SET_ERRORS(state, errors) {
        state.serverErrors = errors;
    },

    INCREMENT_UPDATE_KEY(state) {
        state.updateKey = state.updateKey + 1;
    },

    TOGGLE_FILTER(state, filter) {
        state.filtersEnabled = _.xor(state.filtersEnabled, [filter]);
    },

    SET_AGENTS_FILTER(state, params) {
        state.params['agents'] = params;
    },

    SET_TRAVEL_CONSULTANT_NAMES_FILTER(state, params) {
        state.params['travel_consultant_names'] = params;
    },

    SET_STATUS_FILTER(state, params) {
        state.params['status'] = params;
    },

    SET_PRIORITY_FILTER(state, params) {
        state.params['priority'] = params;
    },

    SET_DIFFICULTY_FILTER(state, params) {
        state.params['difficulty'] = params;
    },

    SET_SOURCE_FILTER(state, params) {
        state.params['source'] = params;
    },

    SET_TAG_FILTER(state, params) {
        state.params['tags'] = params;
    },

    SET_DATE_TICKET_OPENED_FILTER(state, params) {
        state.params['date_ticket_opened'] = params;
    },

    SET_DATE_TICKET_CLOSED_FILTER(state, params) {
        state.params['date_ticket_closed'] = params;
    },

    SET_DATE_TICKET_RESOLVED_FILTER(state, params) {
        state.params['date_ticket_resolved'] = params;
    },

    SET_CAUSED_BY_ITG_ERROR_FILTER(state, params) {
        state.params['caused_by_itg_error'] = params;
    },

    ENCODE_REPORT_PARAMS(state, params) {
        state.report['query'] = JSON.stringify(params);
    },

    SET_PARAMS_FROM_LOADED_REPORT(state) {
        try {
            state.params = JSON.parse(state.report.query);
        } catch ($e) {
            console.log($e);
        }
        if (state.params === null) {
            state.params = _.cloneDeep(PARAMS_BLANK_SLATE);
        }

        state.filtersEnabled = _.keys(state.params);
        
        if (state.params['date_ticket_opened'] === undefined) {
            state.params['date_ticket_opened'] = {
                start_date: null,
                end_date: null
            };
        }
        if (state.params['date_ticket_closed'] === undefined) {
            state.params['date_ticket_closed']  = {
                start_date: null,
                end_date: null
            };
        }
        if (state.params['date_ticket_resolved'] === undefined) {
            state.params['date_ticket_resolved']  = {
                start_date: null,
                end_date: null
            };
        }

        // We have to do this to sort reactivity shit
        state.params = _.cloneDeep(state.params);
    },

    SET_PARAMS_FROM_QUERY(state, query) {
        try {
            state.params = JSON.parse(query);
        } catch ($e) {
            console.log($e);
        }
        if (state.params === null) {
            state.params = _.cloneDeep(PARAMS_BLANK_SLATE);
        }

        state.filtersEnabled = _.keys(state.params);
        
        if (state.params['date_ticket_opened'] === undefined) {
            state.params['date_ticket_opened'] = {
                start_date: null,
                end_date: null
            };
        }
        if (state.params['date_ticket_closed'] === undefined) {
            state.params['date_ticket_closed']  = {
                start_date: null,
                end_date: null
            };
        }
        if (state.params['date_ticket_resolved'] === undefined) {
            state.params['date_ticket_resolved']  = {
                start_date: null,
                end_date: null
            };
        }

        // We have to do this to sort reactivity shit
        state.params = _.cloneDeep(state.params);
    },

    BLANK_SLATE(state) {
        state.report = {
            id: null,
            name: 'Untitled Report',
            description: null,
            query: null
        };
        state.params = _.cloneDeep(PARAMS_BLANK_SLATE);
        state.filtersEnabled = [];
        state.results = null;
    }
}

export const getters = {
    isLoading: (state) => {
        return (state.isLoading || state.isLoadingAgents || state.isLoadingTravelConsultantNames || state.isSaving || state.isDeleting);
    },

    report: (state) => {
        return state.report;
    },

    agents: (state) => {
        return state.agents;
    },

    travelConsultantNames: (state) => {
        return state.travelConsultantNames;
    },

    params: (state) => {
        return state.params;
    },

    results: (state) => {
        return state.results;
    },

    metrics: (state) => {
        return state.metrics;
    },

    updateKey: (state) => {
        return state.updateKey;
    },

    filtersEnabled: (state) => {
        return state.filtersEnabled;
    },

    paramsToUse: (state) => {
        // return _.filter(state.params, (param, key) => {
        //     return true;
        //     // return state.filtersEnabled.includes(key);
        // });

        let params = {};
        _.each(state.filtersEnabled, key => {
            params[key] = state.params[key];
        });
        return params;
    }
}

export const actions = {
    loadReport({commit, getters, dispatch}, id) {
        commit('START_LOADING');
        commit('SET_ERRORS', []);

        // Clear the report if we had a previously loaded report and we are loading a different report
        if (getters.report !== null && getters.report.id !== id) {
            commit('SET_REPORT', null);
        }

        axios.get(API_BASE + '/reports/' + id).then(r => {
            commit('STOP_LOADING');
            commit('SET_REPORT', r.data);
            commit('SET_PARAMS_FROM_LOADED_REPORT');
            commit('INCREMENT_UPDATE_KEY');
            dispatch('runReport');
        }).catch(e => {
            commit('STOP_LOADING');

            let errors;
            if (typeof e.response.data === 'object') {
                errors = _.flatten(_.toArray(e.response.data.errors));
            } else {
                errors = ['Something went wrong. Please try again.'];
            }
            commit('SET_ERRORS', errors);
        });
    },

    loadAgents({commit, getters}) {
        commit('START_LOADING_AGENTS');
        commit('SET_ERRORS', []);

        axios.get(API_BASE + '/users/').then(r => {
            commit('STOP_LOADING_AGENTS');
            commit('SET_AGENTS', r.data);
            commit('INCREMENT_UPDATE_KEY');
        }).catch(e => {
            commit('STOP_LOADING_AGENTS');

            let errors;
            if (typeof e.response.data === 'object') {
                errors = _.flatten(_.toArray(e.response.data.errors));
            } else {
                errors = ['Something went wrong. Please try again.'];
            }
            commit('SET_ERRORS', errors);
        });
    },

    loadTravelConsultantNames({commit, getters}) {
        commit('START_LOADING_TRAVEL_CONSULTANT_NAMES');
        commit('SET_ERRORS', []);

        axios.get(API_BASE + '/travel-consultants/names/cached').then(r => {
            commit('STOP_LOADING_TRAVEL_CONSULTANT_NAMES');
            commit('SET_TRAVEL_CONSULTANT_NAMES', _.without(r.data, null));
            commit('INCREMENT_UPDATE_KEY');
        }).catch(e => {
            commit('STOP_LOADING_TRAVEL_CONSULTANT_NAMES');

            let errors;
            if (typeof e.response.data === 'object') {
                errors = _.flatten(_.toArray(e.response.data.errors));
            } else {
                errors = ['Something went wrong. Please try again.'];
            }
            commit('SET_ERRORS', errors);
        });
    },

    reloadReport({dispatch, getters}) {
        dispatch('loadReport', getters.report.id);
    },

    promptNameAndSaveReport({commit, dispatch}) {
        swal({
            text: 'What would you like to name this report?',
            content: "input",
            button: {
                text: "Save"
            },
        }).then(name => {
            if (name) {
                commit('SET_NAME', name);
                dispatch('saveReport');
            }
        });
    },

    saveReport({commit, getters}) {
        commit('START_SAVING');
        commit('SET_ERRORS', []);
        commit('ENCODE_REPORT_PARAMS', getters.paramsToUse);

        let action;
        if (getters.report && getters.report.id) {
            action = axios.put(API_BASE + '/reports/' + getters.report.id, getters.report);
        } else {
            action = axios.post(API_BASE + '/reports', getters.report);
        }

        action.then(r => {
            commit('STOP_SAVING');
            commit('SET_REPORT', r.data);
            commit('INCREMENT_UPDATE_KEY');
        }).catch(e => {
            commit('STOP_SAVING');
            let errors;
            if (typeof e.response.data === 'object') {
                errors = _.flatten(_.toArray(e.response.data.errors));
            } else {
                errors = ['Something went wrong. Please try again.'];
            }
            commit('SET_ERRORS', errors);
        });
    },

    runReport({commit, getters, dispatch}) {
        commit('START_LOADING');
        commit('SET_ERRORS', []);

        let paramsToUse = {};
        _.each(getters.filtersEnabled, key => {
            paramsToUse[key] = getters.params[key];
        });

        axios.post(API_BASE + '/reports/run', paramsToUse).then(r => {
            commit('STOP_LOADING');
            commit('SET_RESULTS', r.data.tickets);
            commit('SET_METRICS', r.data.metrics);
            commit('INCREMENT_UPDATE_KEY');
            // dispatch('setParamsFromLoadedReport');
        }).catch(e => {
            commit('STOP_LOADING');

            let errors;
            if (typeof e.response.data === 'object') {
                errors = _.flatten(_.toArray(e.response.data.errors));
            } else {
                errors = ['Something went wrong. Please try again.'];
            }
            commit('SET_ERRORS', errors);
        });
    },

    exportResults({commit, getters}) {
        commit('START_SAVING');

        let exportData = [];
        _.each(getters.results, result => {
            exportData.push({
                subject: result.subject,
                status: tickets.getHumanReadableTicketStatus(result.status),
                priority: tickets.getHumanReadableTicketPriority(result.priority),
                difficulty: tickets.getHumanReadableTicketDifficulty(result.difficulty),
                agent: result.agent.name,
                created_at: result.created_at
            });
        });

        const options = {
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalSeparator: '.',
            showLabels: true,
            showTitle: false,
            filename: getters.report.name,
            title: getters.report.name,
            useTextFile: false,
            useBom: true,
            // useKeysAsHeaders: true,
            headers: [
                'Subject',
                'Status',
                'Priority',
                'Difficulty',
                'Agent',
                'Created At'
            ]
        };

        const csvExporter = new ExportToCsv(options);
        csvExporter.generateCsv(exportData);

        commit('STOP_SAVING');
    },

    deleteReport({commit, getters, dispatch}) {
        let vm = this;
        let report = getters.report;
        if (!report.id) {
            return;
        }
        commit('START_DELETING');
        commit('SET_ERRORS', []);
        axios.delete(API_BASE + '/reports/' + report.id).then(r => {
            commit('STOP_DELETING');
            vm._vm.$notify.success({
                title: 'Success!',
                message: 'Report deleted successfully.'
            });
            router.push('/reporting');
        }).catch(e => {
            commit('STOP_DELETING');
            let errors;
            if (typeof e.response.data === 'object') {
                errors = _.flatten(_.toArray(e.response.data.errors));
            } else {
                errors = ['Something went wrong. Please try again.'];
            }
            commit('SET_ERRORS', errors);
            vm._vm.$notify.error({
                title: 'Error',
                message: _.first(errors)
            });
        });
    },

    toggleFilter({getters, commit}, filter) {
        commit('TOGGLE_FILTER', filter);
    },

    setAgentsFilter({commit}, params) {
        commit('SET_AGENTS_FILTER', params);
    },

    setTravelConsultantNamesFilter({commit}, params) {
        commit('SET_TRAVEL_CONSULTANT_NAMES_FILTER', params);
    },

    setStatusFilter({commit}, params) {
        commit('SET_STATUS_FILTER', params);
    },

    setPriorityFilter({commit}, params) {
        commit('SET_PRIORITY_FILTER', params);
    },

    setDifficultyFilter({commit}, params) {
        commit('SET_DIFFICULTY_FILTER', params);
    },

    setSourceFilter({commit}, params) {
        commit('SET_SOURCE_FILTER', params);
    },

    setTagFilter({commit}, params) {
        commit('SET_TAG_FILTER', params);
    },

    setDateTicketOpenedFilter({commit}, params) {
        commit('SET_DATE_TICKET_OPENED_FILTER', params);
    },

    setDateTicketClosedFilter({commit}, params) {
        commit('SET_DATE_TICKET_CLOSED_FILTER', params);
    },

    setDateTicketResolvedFilter({commit}, params) {
        commit('SET_DATE_TICKET_RESOLVED_FILTER', params);
    },

    setCausedByItgErrorFilter({commit}, params) {
        commit('SET_CAUSED_BY_ITG_ERROR_FILTER', params);
    },

    blankSlate({commit}) {
        commit('BLANK_SLATE');
        // commit('SET_PARAMS_FROM_LOADED_REPORT');
        commit('INCREMENT_UPDATE_KEY');
    },

    setParamsFromQuery({commit}, query) {
        commit('SET_PARAMS_FROM_QUERY', query);
        commit('INCREMENT_UPDATE_KEY');
    },

    setAutomatedReportResults({commit}, automatedReportResult) {
        console.log('Results:');
        console.log(automatedReportResult);
        try {
            let results = JSON.parse(automatedReportResult.results);
            commit('SET_RESULTS', results.tickets);
            commit('SET_METRICS', results.metrics);
            commit('INCREMENT_UPDATE_KEY');
        } catch(e) {
            console.log(e);
        }
    }
}